const PLACES = [
  { name: "Pompton Lakes", x: 45, y: 39 },
  { name: "Ridgewood", x: 66, y: 34 },
  { name: "Hackensack", x: 74, y: 53 },
  { name: "Montclair", x: 61, y: 65 },
  { name: "Parsippany", x: 31, y: 56 },
  { name: "Morristown", x: 30, y: 72 },
];

export const ServiceAreaMap = () => (
  <div
    role="img"
    aria-label="Diagram of the service area: Wayne, NJ at the center, with rings out to about 30 miles, reaching towns like Ridgewood, Hackensack, Montclair, Parsippany, and Morristown"
    className="relative mx-auto aspect-square w-full max-w-[520px]"
    data-testid="service-area-map"
  >
    {[33, 66, 100].map((size, i) => (
      <span
        key={size}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/10"
        style={{ width: `${size * 0.9}%`, height: `${size * 0.9}%` }}
      >
        <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#0A0B0D] px-1.5 font-mono text-xs text-[#A1A1AA]">
          {(i + 1) * 10} mi
        </span>
      </span>
    ))}
    <span className="radar-sweep absolute left-[5%] top-[5%] h-[90%] w-[90%]" />
    {PLACES.map((p) => (
      <span key={p.name} className="absolute flex -translate-x-1/2 -translate-y-1/2 items-center gap-1.5" style={{ left: `${p.x}%`, top: `${p.y}%` }}>
        <span className="h-1.5 w-1.5 rounded-full bg-white/60" />
        <span className="whitespace-nowrap text-xs text-white/75">{p.name}</span>
      </span>
    ))}
    <span className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center">
      <span className="h-3 w-3 rounded-full bg-[#2DD4D4] shadow-[0_0_24px_6px_rgba(45,212,212,0.55)]" />
      <span className="mt-2 rounded-full border border-white/15 bg-[#0A0B0D]/80 px-2.5 py-1 text-xs font-medium">Wayne, NJ</span>
    </span>
  </div>
);
